module.exports = __webpack_public_path__ + "static/assets/cf75ae88fe49f37c94da094f52753f51.png";